// Formatting helpers for the attendance dashboard.

// Durations as short text: "45 s", "12 min", "2 h 05 min", "1 d 3 h".
export const formatDuration = seconds => {
	if (seconds === null || seconds === undefined) return "—";

	const total = Math.round(seconds);
	if (total < 60) return `${total} s`;

	const minutes = Math.round(total / 60);
	if (minutes < 60) return `${minutes} min`;

	const hours = Math.floor(minutes / 60);
	const restMinutes = minutes % 60;
	if (hours < 24) {
		return `${hours} h ${String(restMinutes).padStart(2, "0")} min`;
	}

	return `${Math.floor(hours / 24)} d ${hours % 24} h`;
};

// "2026-10-16" -> "16/10"
export const formatDayLabel = key => {
	const [, month, day] = String(key).split("-");
	return `${day}/${month}`;
};
